import classes from "./menu.module.scss";

import React from "react";
import { NavLink } from "react-router-dom";

import { Tooltip } from "@honeycomb/ui";
import classNames from "classnames";

export type MenuLinkProps = React.AllHTMLAttributes<HTMLDivElement> & {
  url: string;
  title: string;
  testLabel: string;
  spacingIconHeight?: string;
  end?: boolean;
};

export const MenuLink = ({ title, url, end, children }: MenuLinkProps) => {
  return (
    <Tooltip title={title} placement={"right"}>
      <NavLink
        to={url}
        className={({ isActive }) => (isActive ? classNames(classes["active-link"]) : classes["nav-link"])}
        style={{
          display: "flex",
          width: "100%",
          height: "72px",
          alignItems: "center",
          justifyContent: "center",
        }}
        end={end}
      >
        {children}
      </NavLink>
    </Tooltip>
  );
};
